import React from "react";

const Home = () => {

    return (
        <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <h2>Coming soon...</h2>
        </div>
    )
};

export default Home;